import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=459f6821&scoped=true"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f6821",
  null
  
)

export default component.exports